import type { EmbarcacaoMotor } from "@/modules/embarcacoes";

/**
 * Ordena os motores pela Ordem Motor, do menor para o maior (RN002). Os motores sem ordem vão para o fim, preservando a
 * ordem em que a fonte os devolveu.
 */
export function byOrdemMotor(first: EmbarcacaoMotor, second: EmbarcacaoMotor): number {
  if (first.ordemMotor === null && second.ordemMotor === null) return 0;
  if (first.ordemMotor === null) return 1;
  if (second.ordemMotor === null) return -1;

  return first.ordemMotor - second.ordemMotor;
}
